import ProcessTimeline from "@/components/SelfProcessTimeline";
import CommonModal from "@/components/ui/CommonModal";
import {
  FlowFormPanelLayout,
  FormSectionLayout,
} from "@/components/ui/FlowFormPanel/FlowFormPanel";
import { FlowModalTitle } from "@/components/ui/FlowModalTitle";
import { BLACKLIST_APPLY_TYPE } from "@/constants";
import { useModal } from "@/hooks/modals/useModal";
import { useFlowNodeQuery } from "@/hooks/services/useFlow";
import { Form } from "antd";
import { useBlacklistRecordDetail } from "../../hooks/useBlacklistRecordDetail";
import { useFormFooter } from "../../hooks/useFormFooter";
import { useInitFormFields } from "../../hooks/useInitFormFields";
import type { BlacklistApplyFormFields } from "../../type";
import { BlacklistApplyForm } from "../BlacklistApplyForm";
import styles from "./BlacklistApplyModal.module.less";
import { useTranslation } from "react-i18next";

export const BlacklistApplyModal = () => {
  const { t } = useTranslation("blacklist");
  const { open, closeModal, props } = useModal("SUPPLIER_BLACK_LIST");
  const { recordId, isFlowFinished, flowStatus, isReadOnly } = props;

  const detail = useBlacklistRecordDetail(recordId);
  const [form] = Form.useForm<BlacklistApplyFormFields>();

  const cleanup = () => {
    closeModal();
    form.resetFields();
  };

  const renderFooter = useFormFooter(form, cleanup);

  const timeLineItems = useFlowNodeQuery(detail?.insId);

  useInitFormFields(form, detail);

  const showFlowStatusRules = [
    isReadOnly,
    flowStatus !== "已通过" &&
      detail?.applyType === BLACKLIST_APPLY_TYPE.ADD_TO,
  ];

  const showFlowStatus = showFlowStatusRules.some((r) => r);

  return (
    <CommonModal
      title={
        <FlowModalTitle
          title={t("供应商黑名单")}
          processCode={detail?.processCode}
        />
      }
      open={open}
      onCancel={cleanup}
      width={1100}
      centered
      className={styles.flowModalWrapper}
      footer={null}
    >
      <FlowFormPanelLayout
        leftPanel={
          <FormSectionLayout
            body={<BlacklistApplyForm form={form} />}
            footer={renderFooter(detail)}
          ></FormSectionLayout>
        }
        rightPanel={
          <ProcessTimeline
            items={timeLineItems}
            showFinishedFlag={isFlowFinished}
          />
        }
        showRightPanel={showFlowStatus && timeLineItems.length > 0}
      ></FlowFormPanelLayout>
    </CommonModal>
  );
};
